/**
 * Distinguish "no snapshot yet" (first build / new conversation) from real restore failures.
 */
export function isBenignMissingSnapshotError(error: unknown): boolean {
  const message =
    error instanceof Error
      ? error.message
      : typeof error === 'string'
        ? error
        : '';

  const normalized = message.toLowerCase();

  if (
    normalized.includes('no snapshot') ||
    normalized.includes('snapshot not found')
  ) {
    return true;
  }

  const status =
    error &&
    typeof error === 'object' &&
    'response' in error &&
    error.response &&
    typeof error.response === 'object' &&
    'status' in error.response
      ? Number((error.response as { status?: number }).status)
      : undefined;

  return status === 404;
}

/** Restore was superseded by a newer bootstrap or explicit pill restore — not a user failure. */
export function isSupersededRestoreError(error: unknown): boolean {
  if (error instanceof DOMException && error.name === 'AbortError') {
    return true;
  }
  if (
    error &&
    typeof error === 'object' &&
    'name' in error &&
    (error as { name?: string }).name === 'AbortError'
  ) {
    return true;
  }
  const message =
    error instanceof Error
      ? error.message
      : typeof error === 'string'
        ? error
        : '';
  return /\baborted\b/i.test(message);
}
